"use strict";
'use client';
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var ui_components_1 = require("@l2p/ui-components");
var styles_module_scss_1 = __importDefault(require("./styles.module.scss"));
var next_intl_1 = require("next-intl");
var react_final_form_1 = require("react-final-form");
var ui_components_2 = require("@l2p/ui-components");
var ui_components_3 = require("@l2p/ui-components");
var apps_shared_1 = require("@l2p/apps-shared");
var useValidationSchema_1 = require("./useValidationSchema");
var ui_components_4 = require("@l2p/ui-components");
var swr_hooks_1 = require("@l2p/swr-hooks");
var navigation_1 = require("next/navigation");
var AddGameLimits = function (_a) {
    var type = _a.type, onClose = _a.onClose;
    var t = (0, next_intl_1.useTranslations)('translation');
    var validationSchema = (0, useValidationSchema_1.useValidationSchema)();
    var currencies = (0, swr_hooks_1.useGenerateCurrencies)();
    var periods = (0, apps_shared_1.useLimitsPeriods)();
    var router = (0, navigation_1.useRouter)();
    var successSetLimitAction = (0, react_1.useCallback)(function () {
        onClose();
        router.refresh();
    }, [onClose, router]);
    // const { setDepositLimit, isSubmitting: depLimLoading } = useSetDepositLimits({
    //   successAction: successSetLimitAction,
    // })
    //
    // const { setLossLimit, isSubmitting: lossLimLoading } = useSetLossLimits({
    //   successAction: successSetLimitAction,
    // })
    //
    // const { setBetLimit, isSubmitting: betLimLoading } = useSetBetLimits({
    //   successAction: successSetLimitAction,
    // })
    var onSubmitHandler = (0, react_1.useCallback)(function (values) {
        return;
        // switch (type) {
        //   case 'deposit':
        //     return setDepositLimit({
        //       maxDeposit: values.amount,
        //       currency: values.currency?.value,
        //       duration: values?.period?.value,
        //     })
        //
        //   case 'bet':
        //     return setBetLimit({
        //       maxBet: values.amount,
        //       currency: values.currency?.value,
        //     })
        //   case 'loss':
        //     return setLossLimit({
        //       maxLoss: values.amount,
        //       currency: values.currency?.value,
        //       duration: values?.period?.value,
        //     })
        // }
    }, []);
    var initialValues = (0, react_1.useMemo)(function () {
        return {
            period: periods[0],
        };
    }, [periods]);
    return (react_1.default.createElement(ui_components_1.Modal, { width: "385px", height: "560px", padding: "0", onClose: onClose },
        react_1.default.createElement("div", { className: styles_module_scss_1.default.container },
            react_1.default.createElement("div", { className: styles_module_scss_1.default.title }, t('addLimitsByType', { type: type })),
            react_1.default.createElement("div", { className: styles_module_scss_1.default.description }, t('addLimitsByTypeDescription', { type: type })),
            react_1.default.createElement(react_final_form_1.Form, { onSubmit: onSubmitHandler, initialValues: initialValues, validate: (0, apps_shared_1.formValidator)(validationSchema), render: function (_a) {
                    var handleSubmit = _a.handleSubmit, submitting = _a.submitting;
                    return (react_1.default.createElement("form", { onSubmit: handleSubmit },
                        (type === 'deposit' || type === 'loss') && (react_1.default.createElement(react_final_form_1.Field, { name: "period", render: function (_a) {
                                var _b;
                                var input = _a.input, meta = _a.meta;
                                return (react_1.default.createElement("div", { className: styles_module_scss_1.default.fieldWrapper },
                                    react_1.default.createElement(ui_components_2.InputSelect, __assign({}, input, { options: periods, labelText: t('period'), hasError: meta.error && meta.touched })),
                                    meta.error && meta.touched && (react_1.default.createElement(ui_components_3.ErrorText, null, (_b = meta.error) === null || _b === void 0 ? void 0 : _b.value))));
                            } })),
                        react_1.default.createElement(react_final_form_1.Field, { name: "amount", render: function (_a) {
                                var input = _a.input, meta = _a.meta;
                                return (react_1.default.createElement("div", { className: styles_module_scss_1.default.fieldWrapper },
                                    react_1.default.createElement(ui_components_2.InputText, __assign({}, input, { placeholder: t('inputAmount'), labelText: t('amount') })),
                                    meta.error && meta.touched && (react_1.default.createElement(ui_components_3.ErrorText, null, meta.error))));
                            } }),
                        react_1.default.createElement(react_final_form_1.Field, { name: "currency", render: function (_a) {
                                var _b;
                                var input = _a.input, meta = _a.meta;
                                return (react_1.default.createElement("div", { className: styles_module_scss_1.default.fieldWrapper },
                                    react_1.default.createElement(ui_components_2.InputSelect, __assign({}, input, { options: currencies, labelText: t('currency'), placeholder: t('selectCurrency'), hasError: meta.error && meta.touched })),
                                    meta.error && meta.touched && (react_1.default.createElement(ui_components_3.ErrorText, null, (_b = meta.error) === null || _b === void 0 ? void 0 : _b.value))));
                            } }),
                        react_1.default.createElement("div", { className: styles_module_scss_1.default.buttonsWrapper },
                            react_1.default.createElement(ui_components_4.FixedButton, { variant: "outline", type: "submit", disabled: submitting, loading: submitting }, t('save')),
                            react_1.default.createElement(ui_components_4.FixedButton, { variant: "outline", color: "black", type: "button", onClick: onClose }, t('cancel')))));
                } }))));
};
exports.default = AddGameLimits;
